let connectedDevice = sessionStorage.getItem('connectedDevice')
const humanoidCommands = {
    English: {
        wave: ['hello', 'hi', 'hey', 'hai', 'hay', 'wave'],
        moveforward: [
            'move forward',
            'walk forward',
            'move',
            'move frond',
            'move front',
            'walk front',
            'forward',
        ],
        movebackward: [
            'move backward',
            'walk backward',
            'move back',
            'walk back',
            'back',
        ],
        turnleft: ['turn left'],
        turnright: ['turn right'],
        moveleft: ['move left'],
        moveright: ['move right'],
        sidekickleft: ['side kick left'],
        sidekickright: ['side kick right'],
        frontkickleft: ['front kick left'],
        frontkickright: ['front kick right'],
        attention: ['attention'],
        salute: ['salute'],
        slideleft: ['slide left'],
        slideright: ['slide right'],
        pushup: [
            'push up',
            'do a push up',
            'push up action',
            'do a push up action',
        ],
        fight: ['fight', 'do a fight', 'fight action', 'do a fight action'],
        dance: ['dance', 'dance for me', 'do a dance'],
        stop: ['stop'],
    },

    Hindi: {
        wave: ['नमस्ते'],
        moveforward: ['आगे चलो', 'आगे'],
        movebackward: ['पीछे जाओ', 'पीछे'],
        turnleft: ['बाएँ मुड़ो'],
        turnright: ['दाएँ मुड़ो'],
        moveleft: ['बाएँ चलो'],
        moveright: ['दाएँ चलो'],
        sidekickleft: ['बायाँ साइड किक'],
        sidekickright: ['दायाँ साइड किक'],
        frontkickleft: ['बायाँ फ्रंट किक'],
        frontkickright: ['दायाँ फ्रंट किक'],
        attention: ['सावधान'],
        salute: ['सलामी'],
        slideleft: ['बाएँ स्लाइड'],
        slideright: ['दाएँ स्लाइड'],
        pushup: ['पुश अप'],
        dance: ['नाचो'],
        stop: ['रुको'],
    },

    Kannada: {
        wave: ['ನಮಸ್ಕಾರ'],
        moveforward: ['ಮುಂದೆ ಹೋಗು'],
        movebackward: ['ಹಿಂದೆ ಹೋಗು'],
        turnleft: ['ಎಡಕ್ಕೆ ತಿರುಗು'],
        turnright: ['ಬಲಕ್ಕೆ ತಿರುಗು'],
        moveleft: ['ಎಡಕ್ಕೆ ಹೋಗು'],
        moveright: ['ಬಲಕ್ಕೆ ಹೋಗು'],
        sidekickleft: ['ಎಡ ಸೈಡ್ ಕಿಕ್'],
        sidekickright: ['ಬಲ ಸೈಡ್ ಕಿಕ್'],
        frontkickleft: ['ಎಡ ಫ್ರಂಟ್ ಕಿಕ್'],
        frontkickright: ['ಬಲ ಫ್ರಂಟ್ ಕಿಕ್'],
        attention: ['ಸಾವಧಾನ'],
        salute: ['ಸಲ್ಯೂಟ್'],
        slideleft: ['ಎಡಕ್ಕೆ ಸ್ಲೈಡ್'],
        slideright: ['ಬಲಕ್ಕೆ ಸ್ಲೈಡ್'],
        pushup: ['ಪುಷ್ ಅಪ್'],
        dance: ['ನೃತ್ಯ'],
        stop: ['ನಿಲ್ಲು'],
    },

    Telugu: {
        wave: ['నమస్కారం'],
        moveforward: ['ముందుకు వెళ్లండి'],
        movebackward: ['వెనక్కి వెళ్లండి'],
        turnleft: ['ఎడమ వైపు తిరుగు'],
        turnright: ['కుడి వైపు తిరుగు'],
        moveleft: ['ఎడమ వైపు వెళ్లండి'],
        moveright: ['కుడి వైపు వెళ్లండి'],
        sidekickleft: ['ఎడమ సైడ్ కిక్'],
        sidekickright: ['కుడి సైడ్ కిక్'],
        frontkickleft: ['ఎడమ ఫ్రంట్ కిక్'],
        frontkickright: ['కుడి ఫ్రంట్ కిక్'],
        attention: ['జాగ్రత్త'],
        salute: ['సల్యూట్'],
        slideleft: ['ఎడమ స్లైడ్'],
        slideright: ['కుడి స్లైడ్'],
        pushup: ['పుష్ అప్'],
        dance: ['నృత్యం'],
        stop: ['ఆగు'],
    },

    Marathi: {
        wave: ['नमस्कार'],
        moveforward: ['पुढे चला'],
        movebackward: ['मागे जा'],
        turnleft: ['डावीकडे वळा'],
        turnright: ['उजवीकडे वळा'],
        moveleft: ['डावीकडे चला'],
        moveright: ['उजवीकडे चला'],
        sidekickleft: ['डावा साइड किक'],
        sidekickright: ['उजवा साइड किक'],
        frontkickleft: ['डावा फ्रंट किक'],
        frontkickright: ['उजवा फ्रंट किक'],
        attention: ['सावधान'],
        salute: ['सलामी'],
        slideleft: ['डावी स्लाइड'],
        slideright: ['उजवी स्लाइड'],
        pushup: ['पुश अप'],
        dance: ['नाच'],
        stop: ['थांबा'],
    },

    Malayalam: {
        wave: ['നമസ്കാരം'],
        moveforward: ['മുന്നോട്ട് പോവുക'],
        movebackward: ['പിന്നോട്ട് പോവുക'],
        turnleft: ['ഇടത്തേക്ക് തിരിയുക'],
        turnright: ['വലത്തേക്ക് തിരിയുക'],
        moveleft: ['ഇടത്തേക്ക് പോവുക'],
        moveright: ['വലത്തേക്ക് പോവുക'],
        sidekickleft: ['ഇടത് സൈഡ് കിക്ക്'],
        sidekickright: ['വലത് സൈഡ് കിക്ക്'],
        frontkickleft: ['ഇടത് ഫ്രണ്ട് കിക്ക്'],
        frontkickright: ['വലത് ഫ്രണ്ട് കിക്ക്'],
        attention: ['സാവധാനം'],
        salute: ['സല്യൂട്ട്'],
        slideleft: ['ഇടത് സ്ലൈഡ്'],
        slideright: ['വലത് സ്ലൈഡ്'],
        pushup: ['പുഷ് അപ്പ്'],
        dance: ['നൃത്തം'],
        stop: ['നിർത്തുക'],
    },
    Odia: {
        wave: ['ନମସ୍କାର'],
        moveforward: ['ଆଗକୁ ଯାଆନ୍ତୁ', 'ଆଗକୁ'],
        movebackward: ['ପଛକୁ ଯାଆନ୍ତୁ', 'ପଛକୁ'],
        turnleft: ['ବାମକୁ ଘୁରନ୍ତୁ'],
        turnright: ['ଡାହାଣକୁ ଘୁରନ୍ତୁ'],
        moveleft: ['ବାମକୁ ଯାଆନ୍ତୁ'],
        moveright: ['ଡାହାଣକୁ ଯାଆନ୍ତୁ'],
        sidekickleft: ['ବାମ ସାଇଡ କିକ୍'],
        sidekickright: ['ଡାହାଣ ସାଇଡ କିକ୍'],
        frontkickleft: ['ବାମ ଫ୍ରଣ୍ଟ କିକ୍'],
        frontkickright: ['ଡାହାଣ ଫ୍ରଣ୍ଟ କିକ୍'],
        attention: ['ସାବଧାନ'],
        salute: ['ସଲ୍ୟୁଟ୍'],
        slideleft: ['ବାମ ସ୍ଲାଇଡ୍'],
        slideright: ['ଡାହାଣ ସ୍ଲାଇଡ୍'],
        pushup: ['ପୁଷ୍ ଅପ୍'],
        dance: ['ନାଚ'],
        stop: ['ଥାମନ୍ତୁ'],
    },
}

const COMMANDS = {
    Humanoid: [
        'hello',
        'hai',
        'hi',
        'hey',
        'hay',
        // 'moveforward',
        'forward',
        // 'backward',
        'back',
        // 'movefront',
        // 'movebackward',
        // 'walkforward',
        // 'waltbackward',
        'turnleft',
        'turnright',
        'moveleft',
        'moveright',
        'sidekickleft',
        'slidekickright',
        'frontkickleft',
        'frontkickright',
        'wave',
        'attention',
        'salute',
        'slideleft',
        'slideright',
        'fight',
        'pushup',
        'dance',
        'stop',
        // 'stopdance',
        // 'stopthedance',
        // 'bow',
        // 'squat',
        'pushup',
    ],
    Ace: [
        'lightoff',
        'whitelight',
        'redlight',
        'greenlight',
        'bluelight',
        'disco',
        'smile',
    ],
    Hexapod: [
        'hello',
        'hai',
        'hi',
        'hey',
        'hay',
        'forward',
        'front',
        'back',
        // 'backward',
        'turnleft',
        'turnright',
        'wave',
        'attention',
        'slideleft',
        'slideright',
        'defence',
        'greet',
        'fight',
        'dance',
        'attack',
        'turnaround',
        // 'around',
        'stop',
    ],
}

const NEGATIONS = ['no', 'dont', "don't"]

// Title-cases a recognised phrase so it can be shown back to the user as spoken
const toDisplayPhrase = (phrase) =>
    phrase.replace(/\b\p{L}/gu, (ch) => ch.toUpperCase())

// matchedPhrases (optional out-param): filled with { COMMAND: 'Phrase As Spoken' }
const humanoidPickCommend = (
    sentence,
    device,
    playModeStorage,
    matchedPhrases
) => {
    let keywords = []

    if (!sentence) return null

    const lang = playModeStorage?.speech?.language || 'English'

    let actionsMap = playModeStorage?.speech?.actionsMap?.[lang] ?? []
    const commandsByLang = humanoidCommands[lang]
    if (!commandsByLang) return null

    // // normalize sentence
    const normalizedSentence = sentence
    //     .toLowerCase()
    //     .replace(/[^\w\s]/g, '')
    //     .trim()

    const matchedWord = {}
    const matchedText = {}
    for (const commandKey in commandsByLang) {
        let commandWords = commandsByLang[commandKey]
        const result = actionsMap.find((item) => item.action === commandKey)
        if (result) {
            commandWords = [...commandWords, result.text]
        }

        // Longest matching phrase wins, so "move front" is not reported as the bare "move"
        let bestWord = null
        for (const word of commandWords) {
            const normalizedWord = word.replaceAll(' ', '').toLowerCase()

            // exact word OR phrase match
            if (
                normalizedSentence.includes(normalizedWord) &&
                (bestWord === null || normalizedWord.length > bestWord.normalized.length)
            ) {
                bestWord = { normalized: normalizedWord, word }
            }
        }
        if (bestWord) {
            keywords.push(commandKey)
            matchedWord[commandKey] = bestWord.normalized
            matchedText[commandKey] = bestWord.word
        }
    }

    // The bare word "move" must not fire forward when a specific direction was also said.
    if (
        matchedWord.moveforward === 'move' &&
        ['movebackward', 'moveleft', 'moveright'].some((k) =>
            keywords.includes(k)
        )
    ) {
        keywords = keywords.filter((k) => k !== 'moveforward')
    }

    // if encountered a negation the next command is ignored
    let encounteredNegation = false
    keywords.map((command) => {
        if (NEGATIONS.includes(command)) encounteredNegation = true
    })
    if (encounteredNegation) keywords = []

    if (matchedPhrases) {
        keywords.forEach((command) => {
            matchedPhrases[command.toUpperCase()] = toDisplayPhrase(
                matchedText[command].trim()
            )
        })
    }

    keywords = keywords.map((command) => command.toUpperCase())
    return keywords
}

const pickCommandFromSentence = (
    sentence,
    device,
    playModeStorage,
    matchedPhrases
) => {
    const keywords = []
    if (device === 'Humanoid') {
        return humanoidPickCommend(
            sentence,
            device,
            playModeStorage,
            matchedPhrases
        )
    } else {
        keywords.push(...COMMANDS[device], ...NEGATIONS)
    }
    const validKeyWords = keywords.filter((command) =>
        sentence.includes(command)
    )

    let commands = validKeyWords.map((keyWord) => {
        if (
            ['hello', 'hai', 'hi', 'hay', 'hey', 'greet', 'wave'].includes(
                keyWord
            ) &&
            connectedDevice == 'Hexapod'
        )
            return 'greeting'
        if (
            ['around', 'turn around', 'turnaround'].includes(keyWord) &&
            connectedDevice == 'Hexapod'
        )
            return 'turnaround'
        else if (['hello', 'hai', 'hi', 'hay', 'hey'].includes(keyWord))
            return 'wave'

        return keyWord
    })

    // if encountered a negation the next command is ignored
    let encounteredNegation = false
    commands.map((command) => {
        if (NEGATIONS.includes(command)) encounteredNegation = true
    })
    if (encounteredNegation) commands = []

    commands = commands.map((command) => command.toUpperCase())
    return commands
}

// matchedPhrases (optional out-param): receives the phrase actually spoken for each
// returned command, so the UI can show it instead of the generic command name.
const speechToCommand = (input, device, playModeStorage, matchedPhrases) => {
    // ---- EXACT STRICT MATCHING FOR HEXAPOD ----
    if (device === 'Hexapod') {
        // Strip punctuation and whitespace for matching
        let cleanInput = input.toLowerCase().replace(/[.,!?;:\s]/g, '')

        // Strict 1-to-1 mapping for only the exact predefined phrases in the UI
        const hexapodExactCommands = {
            'walkforward': 'FORWARD',
            'moveforward': 'FORWARD',
            'walkfront': 'FRONT',
            'movefront': 'FRONT',
            'walkbackward': 'BACK',
            'movebackward': 'BACK',
            'walkback': 'BACK',
            'moveback': 'BACK',
            'turnleft': 'TURNLEFT',
            'turnright': 'TURNRIGHT',
            'attention': 'ATTENTION',
            'slideleft': 'SLIDELEFT',
            'slideright': 'SLIDERIGHT',
            'wave': 'GREETING',
            'dance': 'DANCE',
            'danceforme': 'DANCE',
            'attack': 'ATTACK',
            'stop': 'STOP',
            'defence': 'DEFENCE',
            'defense': 'DEFENCE', 
            'turnaround': 'TURNAROUND'
        }

        // Check for negations first
        const hasNegation = ['no', 'dont', 'don\'t'].some(neg => 
            input.toLowerCase().includes(neg)
        )
        if (hasNegation) return []

        // Return the command only if it exactly matches one of the predefined phrases
        if (hexapodExactCommands[cleanInput]) {
            const command = hexapodExactCommands[cleanInput]
            if (matchedPhrases) {
                matchedPhrases[command] = toDisplayPhrase(
                    input.trim().toLowerCase().replace(/[.,!?;:]/g, '')
                )
            }
            return [command]
        }
        
        // Return empty if no predefined phrase was exactly detected
        return []
    }
    // ---------------------------------------------

    // ORIGINAL LOGIC for Humanoid and Ace
    let sentence = input.replaceAll(' ', '').toLowerCase()
    return pickCommandFromSentence(
        sentence,
        device,
        playModeStorage,
        matchedPhrases
    )
}

export default speechToCommand
